import { render, staticRenderFns } from "./SetBetAmount.vue?vue&type=template&id=e95bfef0&scoped=true&"
import script from "./SetBetAmount.vue?vue&type=script&lang=js&"
export * from "./SetBetAmount.vue?vue&type=script&lang=js&"
import style0 from "./SetBetAmount.vue?vue&type=style&index=0&id=e95bfef0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95bfef0",
  null
  
)

export default component.exports